var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisteon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    id: "bosch",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.28 364.53h21.46l31.64 97.69h.37l32.23-97.69h21.63L452.7 485.95h-24.89l-40.53-121.42z",
    fillRule: "evenodd",
    id: "polygon8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.87 485.95h17.88v-94.93h-17.88v94.93z",
    fillRule: "evenodd",
    id: "polygon10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.74 431.32c10 6.1 22 12.37 22 28.06 0 20.06-14.34 28.78-35.8 28.78a84 84 0 0 1-25.39-3.78v-15.79c1.75.83 13.83 5.64 23.92 5.64 8.54 0 19.22-2.49 19.22-12.23 0-7.2-8.68-11.19-15.07-15.37l-9.19-5.56c-8.54-5.37-18.89-11.74-18.89-25.74 0-17.17 13.84-26.56 33.68-26.56 9.47 0 17 2.53 21.48 3.43v16.13c-2.57-1.17-11.36-5.63-21.76-5.63-7.65 0-15.51 4.22-15.51 10.22 0 6.65 7.51 10.3 13.76 14l7.52 4.4z",
    fillRule: "evenodd",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.56 486.78a64.29 64.29 0 0 1-14.1 1.38c-22.94 0-28.53-10.16-28.53-23.2V405H638v-14h16.92v-22.36l17.81-11.19V391h26.33v14h-26.32v50.74c0 8.5 1.37 18.54 15.31 18.54a37.58 37.58 0 0 0 9.51-1.37v13.92z",
    fillRule: "evenodd",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.8 470.8c-4.22 1.42-9.78 3.43-18 3.43-26 0-34.94-24.93-34.94-42.7h55.2v-4.61c0-22.37-11.19-38.15-34.5-38.15-12 0-38.55 4.46-38.55 45.16 0 37.27 18.33 54.23 47 54.23 10.43 0 16-1.37 23.78-3.16v-14.2zm-52.07-51.23c0-4.25 4.12-16.87 18.95-16.87 13.87 0 17.37 10.78 17.37 16.87z",
    fillRule: "evenodd",
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830 438.54c0-15.33 2.33-35.84 22-35.84 19.45 0 22 20.51 22 35.84 0 15.1-2.58 35.69-22 35.69-19.64 0-22-20.59-22-35.69zm22 49.62c28.69 0 42-19.74 42-49.62 0-30.35-13.32-49.77-42-49.77s-42 19.42-42 49.77c0 29.88 13.32 49.62 42 49.62z",
    fillRule: "evenodd",
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.86 391H940v20.39h.27c3.23-8.11 10.81-22.65 30.24-22.65 21.83 0 25.37 19.56 25.37 31.43V486H978v-51.93c0-17.5 0-27.33-13-27.33-14.76 0-25 20-25 38.86V486h-18.14v-95z",
    fillRule: "evenodd",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.19 525.71c0-4-5.63-7.35-12.15-7.35-6.83 0-12.36 3.36-12.36 7.35S936.21 533 943 533c6.52 0 12.15-3.29 12.15-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.19 574.65c0-4.12-5.63-7.35-12.15-7.35-6.83 0-12.36 3.23-12.36 7.35s5.53 7.27 12.36 7.27c6.52 0 12.15-3.29 12.15-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.4 618.58c0-4.8-6.61-8.78-14.72-8.78s-14.83 4-14.83 8.78 6.77 9 14.83 9 14.72-4 14.72-9z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931 665.13c0-5.77-7.79-10.51-17.33-10.51s-17.5 4.74-17.5 10.51 7.93 10.49 17.5 10.49S931 670.9 931 665.13z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.69 699.3c0-6.58-9-12-20-12-10.84 0-20 5.43-20 12s9.18 12 20 12c11 0 20-5.34 20-12z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874 733.62c0-7.94-11-14.41-24.05-14.41-13.26 0-23.93 6.47-23.93 14.41S836.67 748 849.93 748c13 0 24.05-6.46 24.05-14.36z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.55 758c0-6.78-9.38-12.35-20.56-12.35-11.36 0-20.53 5.57-20.53 12.35s9.16 12.36 20.53 12.36c11.18 0 20.56-5.55 20.56-12.36z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.94 777.56c0-8.64-12-15.79-26.37-15.79s-26.19 7.15-26.19 15.79c0 8.79 11.67 15.87 26.19 15.87s26.37-7.08 26.37-15.87z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.62 787.46c0-8.1-11-14.77-24.27-14.77s-24.24 6.67-24.24 14.77c0 7.94 10.85 14.41 24.24 14.41s24.27-6.47 24.27-14.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.47 789.86c0-8.72-11.8-15.79-26.25-15.79s-26.33 7.07-26.33 15.79 11.91 15.79 26.33 15.79 26.25-7.16 26.25-15.79z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.94 787.46c0-8.79-11.91-15.87-26.26-15.87s-26.32 7.08-26.32 15.87c0 8.63 11.84 15.78 26.32 15.78s26.26-7.15 26.26-15.78z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.3 777.56c0-7.12-9.85-13-21.72-13s-21.66 5.91-21.66 13c0 7.29 9.72 13.13 21.66 13.13s21.72-5.84 21.72-13.13z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.19 758c0-6.78-9.3-12.35-20.45-12.35-11.36 0-20.53 5.57-20.53 12.35s9.17 12.36 20.53 12.36c11.15 0 20.45-5.55 20.45-12.36z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.62 731.16c0-6-8.17-10.78-17.88-10.78-9.92 0-17.95 4.8-17.95 10.78s8 10.7 17.95 10.7c9.71 0 17.88-4.72 17.88-10.7z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 701.79c0-5.92-8-10.86-17.85-10.86s-17.87 4.94-17.87 10.86 8 10.84 17.87 10.84S320 707.75 320 701.79z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.79 665.13c0-5-6.63-8.93-14.72-8.93s-14.87 4-14.87 8.93 6.7 8.88 14.87 8.88 14.72-4 14.72-8.88z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.76 621.13c0-4.94-6.79-8.92-14.82-8.92-8.2 0-14.83 4-14.83 8.92s6.63 8.84 14.83 8.84c8 0 14.82-4 14.82-8.84z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.81 577.11c0-4.12-5.56-7.38-12.18-7.38-6.8 0-12.3 3.26-12.3 7.38s5.5 7.3 12.3 7.3c6.62 0 12.18-3.31 12.18-7.3z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.27 528.11c0-4-5.39-7.29-12.22-7.29-6.66 0-12.11 3.3-12.11 7.29s5.45 7.42 12.11 7.42c6.83 0 12.22-3.3 12.22-7.42z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.65 474.36c0-4-5.5-7.28-12.25-7.28s-12.15 3.24-12.15 7.28 5.42 7.34 12.15 7.34 12.25-3.29 12.25-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.89 423c0-4-5.55-7.35-12.32-7.35S1.39 419 1.39 423s5.61 7.3 12.18 7.3 12.32-3.3 12.32-7.3z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.17 332.48c0-4-5.42-7.35-12.18-7.35s-12.22 3.36-12.22 7.35 5.46 7.41 12.22 7.41 12.18-3.38 12.18-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 376.47c0-4-5.49-7.27-12.22-7.27s-12.09 3.29-12.09 7.27 5.44 7.35 12.09 7.35S65 380.53 65 376.47z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.52 423c0-4-5.49-7.35-12.18-7.35S60 419 60 423s5.52 7.29 12.32 7.29 12.2-3.29 12.2-7.29z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 467.08c0-4.05-5.59-7.41-12.22-7.41s-12.12 3.33-12.12 7.41 5.35 7.28 12.11 7.28 12.23-3.31 12.23-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.81 511c0-4-5.56-7.27-12.18-7.27-6.8 0-12.3 3.29-12.3 7.27s5.5 7.35 12.3 7.35c6.62 0 12.18-3.28 12.18-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.81 557.46c0-4-5.49-7.25-12.15-7.25-6.86 0-12.36 3.3-12.36 7.25s5.5 7.38 12.36 7.38c6.66 0 12.15-3.3 12.15-7.38z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.72 596.54c0-4-5.52-7.27-12.25-7.27s-12.19 3.29-12.19 7.27 5.5 7.43 12.19 7.43 12.25-3.3 12.25-7.43z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.14 633.27c0-4.8-6.73-8.92-14.8-8.92s-14.79 4.12-14.79 8.92 6.76 8.93 14.79 8.93 14.8-4 14.8-8.93z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 665.13c0-5.77-7.87-10.51-17.34-10.51s-17.4 4.74-17.4 10.51 7.82 10.49 17.4 10.49S344 670.9 344 665.13z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.74 694.49c0-6-8-10.83-17.89-10.83s-17.91 4.87-17.91 10.83 8 10.79 17.91 10.79 17.89-4.86 17.89-10.79z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.31 716.46c0-7.2-9.82-13-21.73-13s-21.73 5.84-21.73 13 9.75 13.13 21.73 13.13 21.73-6 21.73-13.13z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.87 731.16c0-7.2-9.92-13-21.72-13-12 0-21.66 5.84-21.66 13s9.68 13.05 21.66 13.05c11.8 0 21.72-5.91 21.72-13.05z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.56 741c0-7.21-9.82-13.1-21.69-13.1s-21.69 5.89-21.69 13.1 9.71 13 21.69 13 21.69-5.84 21.69-13z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.41 743.32c0-7.08-9.84-13-21.79-13s-21.69 6-21.69 13c0 7.27 9.75 13.1 21.69 13.1s21.79-5.83 21.79-13.1z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.12 741c0-7.21-9.66-13.1-21.69-13.1-11.79 0-21.61 5.89-21.61 13.1s9.82 13 21.61 13c12 0 21.69-5.84 21.69-13z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.83 731.16c0-6-8.16-10.78-18-10.78S705 725.18 705 731.16s8.06 10.7 17.85 10.7 18-4.72 18-10.7z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.69 714c0-4.83-6.69-8.78-14.76-8.78S752 709.17 752 714s6.74 8.92 14.94 8.92 14.76-4 14.76-8.92z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.74 692c0-4.06-5.43-7.43-12.12-7.43-6.87 0-12.25 3.37-12.25 7.43s5.38 7.33 12.25 7.33c6.69 0 12.12-3.29 12.12-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.12 667.52c0-4-5.57-7.35-12.18-7.35-6.84 0-12.3 3.3-12.3 7.35s5.46 7.35 12.3 7.35c6.61 0 12.18-3.29 12.18-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872 633.27c0-4-5.46-7.34-12.22-7.34s-12.15 3.35-12.15 7.34 5.53 7.34 12.15 7.34 12.22-3.29 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.25 596.54c0-4-5.56-7.27-12.26-7.27s-12.22 3.29-12.22 7.27S865.3 604 872 604s12.26-3.3 12.26-7.43z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.46 555.09c0-4.06-5.49-7.35-12.18-7.35S872 551 872 555.09s5.53 7.26 12.29 7.26 12.18-3.21 12.18-7.26z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.9 621.13c0-4.06-5.5-7.35-12.25-7.35s-12.26 3.29-12.26 7.35 5.53 7.34 12.26 7.34 12.25-3.37 12.25-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.83 648c0-4-5.49-7.35-12.18-7.35s-12.34 3.31-12.34 7.35 5.61 7.35 12.34 7.35 12.18-3.38 12.18-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.57 670c0-4-5.53-7.33-12.19-7.33S730.2 666 730.2 670s5.49 7.29 12.18 7.29 12.19-3.29 12.19-7.29z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.31 687.09c0-4-5.42-7.27-12.08-7.27-6.83 0-12.32 3.29-12.32 7.27s5.49 7.4 12.32 7.4c6.66 0 12.08-3.28 12.08-7.4z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.85 696.84c0-4-5.56-7.28-12.22-7.28-6.82 0-12.32 3.31-12.32 7.28s5.5 7.41 12.32 7.41c6.66 0 12.22-3.29 12.22-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.43 660.17c0-4-5.41-7.33-12.14-7.33S647 656.2 647 660.17s5.49 7.35 12.29 7.35 12.14-3.29 12.14-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.84 667.52c0-4-5.39-7.35-12.22-7.35-6.59 0-12.11 3.3-12.11 7.35s5.52 7.35 12.11 7.35c6.83 0 12.22-3.29 12.22-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.5 667c0-4-5.42-7.34-12.15-7.34S566.1 663 566.1 667s5.6 7.29 12.25 7.29 12.15-3.17 12.15-7.29z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.17 665.13c0-4-5.49-7.27-12.22-7.27s-12.25 3.22-12.25 7.27 5.56 7.34 12.25 7.34 12.22-3.29 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.16 634.17c0-4.09-5.46-7.35-12.22-7.35s-12.12 3.26-12.12 7.35 5.49 7.34 12.12 7.34 12.22-3.31 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.07 626.41c0-4-5.56-7.28-12.29-7.28s-12.22 3.29-12.22 7.28 5.53 7.34 12.22 7.34 12.29-3.29 12.29-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 655.45c0-4.06-5.56-7.35-12.22-7.35s-12.22 3.29-12.22 7.35 5.57 7.27 12.22 7.27S501 659.4 501 655.45z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.52 643.84c0-4.05-5.43-7.31-12.15-7.31S430 639.79 430 643.84s5.59 7.35 12.35 7.35 12.15-3.29 12.15-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.44 614.81c0-4-5.57-7.28-12.23-7.28s-12.21 3.3-12.21 7.28 5.53 7.35 12.22 7.35 12.23-3.3 12.23-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 585.78c0-4-5.52-7.25-12.25-7.25s-12.21 3.26-12.21 7.25 5.52 7.41 12.21 7.41 12.25-3.3 12.25-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.52 603.2c0-4-5.52-7.27-12.21-7.27s-12.18 3.24-12.18 7.27 5.52 7.35 12.18 7.35 12.21-3.23 12.21-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.11 626.41c0-4-5.45-7.28-12.28-7.28-6.62 0-12.18 3.29-12.18 7.28s5.55 7.34 12.18 7.34c6.83 0 12.28-3.29 12.28-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.62 605.2c0-4.12-5.56-7.35-12.21-7.35s-12.26 3.23-12.26 7.35 5.49 7.26 12.26 7.26 12.21-3.28 12.21-7.26z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 583.81c0-3.95-5.53-7.24-12.21-7.24s-12.15 3.29-12.15 7.24 5.42 7.45 12.15 7.45S383 587.9 383 583.81z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.11 570.34c0-4.07-5.45-7.36-12.28-7.36-6.62 0-12.18 3.29-12.18 7.36s5.55 7.33 12.18 7.33c6.83 0 12.28-3.31 12.28-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.37 553c0-4.05-5.53-7.34-12.39-7.34-6.66 0-12.19 3.29-12.19 7.34s5.53 7.28 12.19 7.28c6.86 0 12.39-3.23 12.39-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.16 562.57c0-4.05-5.45-7.33-12.18-7.33s-12.19 3.28-12.19 7.33 5.43 7.34 12.19 7.34 12.18-3.22 12.18-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 580c0-4-5.46-7.35-12.25-7.35S298.53 576 298.53 580s5.49 7.35 12.25 7.35S323 584 323 580z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.32 551c0-4.06-5.53-7.28-12.16-7.28S260 546.91 260 551s5.43 7.35 12.15 7.35 12.16-3.23 12.16-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.38 535.53c0-4.07-5.56-7.29-12.25-7.29s-12.32 3.22-12.32 7.29 5.64 7.35 12.32 7.35 12.25-3.24 12.25-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.28 533.6c0-4.05-5.49-7.29-12.16-7.29s-12.21 3.24-12.21 7.29 5.52 7.35 12.21 7.35 12.16-3.31 12.16-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.16 510.4c0-4-5.47-7.28-12.19-7.28s-12.18 3.29-12.18 7.28 5.45 7.33 12.18 7.33 12.19-3.34 12.19-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.38 512.33c0-4.06-5.56-7.35-12.25-7.35s-12.32 3.29-12.32 7.35 5.64 7.26 12.32 7.26 12.25-3.23 12.25-7.26z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41 510.4c0-4-5.39-7.28-12.18-7.28s-12.15 3.29-12.15 7.28 5.42 7.33 12.15 7.33 12.18-3.34 12.18-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44 522.07c0-4.05-5.43-7.48-12.18-7.48s-12.15 3.43-12.15 7.48 5.46 7.27 12.15 7.27 12.18-3.28 12.18-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.52 488.77c0-4.11-5.46-7.34-12.19-7.34s-12.18 3.23-12.18 7.34 5.49 7.28 12.18 7.28 12.19-3.29 12.19-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24 484.79c0-4-5.52-7.21-12.26-7.21s-12.11 3.23-12.11 7.21 5.49 7.42 12.11 7.42 12.26-3.31 12.26-7.42z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.89 486.78c0-4-5.35-7.34-12.08-7.34s-12.29 3.37-12.29 7.34 5.53 7.35 12.29 7.35 12.08-3.3 12.08-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 488.77c0-4.11-5.53-7.34-12.22-7.34s-12.26 3.23-12.26 7.34 5.5 7.28 12.26 7.28 12.22-3.29 12.22-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.75 461.66c0-4.05-5.42-7.43-12.22-7.43s-12.15 3.38-12.15 7.43 5.46 7.34 12.15 7.34 12.22-3.3 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71 465.51c0-4-5.49-7.36-12.29-7.36-6.59 0-12.22 3.38-12.22 7.36s5.63 7.35 12.22 7.35c6.8 0 12.29-3.27 12.29-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9 459.67c0-4-5.42-7.27-12.29-7.27s-12.22 3.29-12.22 7.27 5.5 7.41 12.22 7.41 12.29-3.36 12.29-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22 450.06c0-4.06-5.53-7.28-12.26-7.28s-12.24 3.22-12.24 7.28 5.49 7.35 12.24 7.35 12.26-3.3 12.26-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.31 455.82c0-4-5.49-7.31-12.22-7.31S171 451.84 171 455.82s5.35 7.43 12.07 7.43 12.22-3.38 12.22-7.43z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.17 419.51c0-4.06-5.59-7.35-12.29-7.35s-12.22 3.29-12.22 7.35 5.57 7.31 12.22 7.31 12.29-3.33 12.29-7.31z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.76 421.38c0-4-5.47-7.3-12.19-7.3s-12.26 3.3-12.26 7.3 5.46 7.4 12.26 7.4 12.19-3.38 12.19-7.4z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.39 433.05c0-4.13-5.39-7.43-12.18-7.43s-12.21 3.3-12.21 7.43 5.42 7.33 12.19 7.33 12.18-3.31 12.18-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34 440.72c0-4-5.49-7.28-12.3-7.28s-12.2 3.29-12.2 7.28 5.41 7.34 12.2 7.34 12.3-3.29 12.3-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.38 440.72c0-4-5.53-7.28-12.3-7.28s-12.14 3.29-12.14 7.28 5.45 7.34 12.14 7.34 12.3-3.29 12.3-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.82 421.38c0-4-5.53-7.3-12.21-7.3s-12.12 3.3-12.12 7.3 5.46 7.4 12.12 7.4 12.21-3.38 12.21-7.4z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.75 415.66c0-4-5.57-7.42-12.29-7.42s-12.15 3.38-12.15 7.42 5.42 7.28 12.15 7.28 12.29-3.29 12.29-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.85 407.9c0-4-5.56-7.41-12.28-7.41s-12.22 3.38-12.22 7.41 5.53 7.35 12.22 7.35 12.28-3.29 12.28-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.31 390.51c0-4-5.49-7.38-12.16-7.38s-12.28 3.36-12.28 7.38 5.56 7.38 12.28 7.38 12.16-3.37 12.16-7.38z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51 384.67c0-4-5.56-7.37-12.11-7.37-6.8 0-12.33 3.35-12.33 7.37S141.6 392 148.4 392c6.55 0 12.11-3.3 12.11-7.32z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86 349.84c0-4.06-5.6-7.35-12.26-7.35s-12.28 3.29-12.28 7.35 5.59 7.35 12.28 7.35 12.26-3.38 12.26-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.31 363.36c0-4.05-5.49-7.34-12.22-7.34S171 359.31 171 363.36s5.35 7.34 12.07 7.34 12.22-3.3 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.21 382.72c0-4.05-5.53-7.28-12.25-7.28s-12.19 3.23-12.19 7.28 5.47 7.33 12.19 7.33 12.25-3.29 12.25-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 394.32c0-4-5.52-7.28-12.18-7.28s-12.32 3.29-12.32 7.28 5.63 7.4 12.32 7.4 12.18-3.29 12.18-7.4z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.89 400.09c0-4-5.35-7.35-12.08-7.35s-12.29 3.37-12.29 7.35 5.53 7.33 12.29 7.33 12.08-3.21 12.08-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.19 378.86c0-4-5.42-7.25-12.22-7.25s-12.22 3.29-12.22 7.25c0 4.13 5.57 7.36 12.22 7.36s12.22-3.23 12.22-7.36z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.15 373c0-4-5.47-7.26-12.29-7.26-6.56 0-12.15 3.29-12.15 7.26 0 4.12 5.59 7.41 12.15 7.41 6.82 0 12.29-3.29 12.29-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.15 351.76c0-4-5.47-7.35-12.29-7.35-6.56 0-12.15 3.34-12.15 7.35s5.59 7.35 12.15 7.35c6.82 0 12.29-3.29 12.29-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.84 332.48c0-4.06-5.49-7.35-12.08-7.35-6.76 0-12.29 3.29-12.29 7.35s5.53 7.33 12.29 7.33c6.59 0 12.08-3.3 12.08-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.57 313.12c0-4-5.39-7.35-12.05-7.35-6.84 0-12.32 3.32-12.32 7.35s5.48 7.34 12.32 7.34c6.66 0 12.05-3.37 12.05-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.32 295.67c0-4-5.53-7.27-12.16-7.27S260 291.69 260 295.67s5.43 7.42 12.15 7.42 12.16-3.36 12.16-7.42z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71 284.21c0-4.12-5.49-7.33-12.29-7.33-6.59 0-12.22 3.21-12.22 7.33 0 3.91 5.63 7.28 12.22 7.28 6.8 0 12.29-3.37 12.29-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 272.54c0-4.05-5.46-7.28-12.25-7.28s-12.25 3.23-12.25 7.28 5.49 7.34 12.25 7.34 12.25-3.35 12.25-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.16 266.71c0-4-5.45-7.34-12.18-7.34s-12.19 3.35-12.19 7.34 5.43 7.34 12.19 7.34 12.18-3.29 12.18-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.18 262.8c0-4-5.43-7.42-12.09-7.42s-12.28 3.43-12.28 7.42 5.59 7.34 12.28 7.34 12.09-3.3 12.09-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.48 262.8c0-4-5.49-7.42-12.18-7.42s-12.12 3.43-12.12 7.42 5.46 7.34 12.12 7.34 12.18-3.3 12.18-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.54 262.8c0-4-5.56-7.42-12.22-7.42s-12.24 3.43-12.24 7.42 5.45 7.34 12.24 7.34 12.22-3.3 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.52 268.64c0-4.07-5.43-7.35-12.15-7.35S430 264.57 430 268.64s5.59 7.34 12.35 7.34 12.15-3.37 12.15-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.4 276.39c0-4.06-5.46-7.35-12.12-7.35-6.86 0-12.32 3.29-12.32 7.35s5.46 7.27 12.32 7.27c6.66 0 12.12-3.22 12.12-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.51 286.05c0-4.11-5.56-7.4-12.29-7.4s-12.22 3.29-12.22 7.4 5.56 7.3 12.22 7.3 12.29-3.3 12.29-7.3z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.53 301.5c0-4-5.49-7.34-12.18-7.34s-12.16 3.31-12.16 7.34 5.5 7.35 12.16 7.35 12.18-3.36 12.18-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.52 315c0-4-5.5-7.27-12.29-7.27-6.59 0-12.18 3.22-12.18 7.27s5.59 7.35 12.18 7.35c6.79 0 12.29-3.23 12.29-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 346c0-4.05-5.49-7.34-12.12-7.34S561.71 342 561.71 346s5.49 7.33 12.14 7.33S586 350 586 346z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.85 330.55c0-4.12-5.47-7.43-12.16-7.43s-12.25 3.31-12.25 7.43c0 3.9 5.56 7.33 12.25 7.33s12.16-3.43 12.16-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.87 317c0-4.06-5.42-7.29-12.28-7.29-6.66 0-12.11 3.23-12.11 7.29s5.45 7.27 12.11 7.27c6.86 0 12.28-3.29 12.28-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.68 305.36c0-4.06-5.56-7.38-12.22-7.38s-12.22 3.32-12.22 7.38 5.46 7.34 12.22 7.34 12.22-3.3 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.56 293.75c0-4-5.38-7.35-12.15-7.35s-12.22 3.38-12.22 7.35 5.43 7.36 12.22 7.36 12.15-3.24 12.15-7.36z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.44 287.91c0-4-5.57-7.35-12.23-7.35S434 283.94 434 287.91s5.53 7.41 12.22 7.41 12.23-3.29 12.23-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.15 282.15c0-4-5.52-7.42-12.25-7.42s-12.25 3.37-12.25 7.42 5.62 7.34 12.25 7.34 12.25-3.29 12.25-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.11 282.15c0-4-5.45-7.42-12.28-7.42-6.62 0-12.18 3.37-12.18 7.42s5.55 7.34 12.18 7.34c6.83 0 12.28-3.29 12.28-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path264"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.83 284.21c0-4.12-5.49-7.33-12.11-7.33-6.8 0-12.22 3.21-12.22 7.33 0 3.91 5.42 7.28 12.22 7.28 6.62 0 12.11-3.37 12.11-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.67 286.05c0-4.11-5.53-7.4-12.12-7.4-6.9 0-12.43 3.29-12.43 7.4s5.53 7.3 12.43 7.3c6.59 0 12.12-3.3 12.12-7.3z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32 295.67c0-4-5.49-7.27-12.16-7.27s-12.28 3.29-12.28 7.27 5.53 7.42 12.28 7.42 12.16-3.36 12.16-7.42z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 305.36c0-4.06-5.53-7.38-12.22-7.38s-12.26 3.32-12.26 7.38 5.5 7.34 12.26 7.34 12.22-3.3 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.38 317c0-4.06-5.56-7.29-12.25-7.29S288.81 313 288.81 317s5.64 7.27 12.32 7.27 12.25-3.27 12.25-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.79 328.55c0-3.91-5.6-7.27-12.23-7.27-6.79 0-12.35 3.36-12.35 7.27s5.56 7.42 12.35 7.42c6.63 0 12.23-3.37 12.23-7.42z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.91 342.14c0-4-5.53-7.35-12.18-7.35s-12.28 3.31-12.28 7.35 5.59 7.29 12.28 7.29 12.18-3.31 12.18-7.29z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.12 361.44c0-4-5.43-7.34-12.26-7.34-6.66 0-12.15 3.35-12.15 7.34s5.49 7.33 12.15 7.33c6.83 0 12.26-3.28 12.26-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22 355.68c0-4.12-5.53-7.36-12.26-7.36s-12.24 3.24-12.24 7.36 5.49 7.26 12.24 7.26 12.26-3.15 12.26-7.26z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.54 332.48c0-4.06-5.49-7.35-12.22-7.35s-12.22 3.29-12.22 7.35 5.56 7.33 12.22 7.33 12.22-3.3 12.22-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86 319c0-4.06-5.6-7.35-12.26-7.35s-12.28 3.29-12.28 7.35 5.59 7.35 12.28 7.35 12.26-3.35 12.26-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.51 286.05c0-4.11-5.56-7.4-12.11-7.4-6.8 0-12.33 3.29-12.33 7.4s5.53 7.3 12.33 7.3c6.55 0 12.11-3.3 12.11-7.3z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.17 262.8c0-4-5.59-7.42-12.29-7.42s-12.22 3.43-12.22 7.42 5.57 7.34 12.22 7.34 12.29-3.3 12.29-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.59 233.83c0-4.06-5.47-7.35-12.26-7.35s-12.22 3.29-12.22 7.35 5.45 7.31 12.22 7.31 12.26-3.33 12.26-7.31z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.66 214.41c0-4-5.4-7.3-12.12-7.3s-12.08 3.31-12.08 7.3 5.42 7.33 12.08 7.33 12.12-3.21 12.12-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.78 200.94c0-4.12-5.6-7.34-12.29-7.34s-12.19 3.22-12.19 7.34 5.5 7.29 12.19 7.29 12.29-3.23 12.29-7.29z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path296"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41 187.42c0-4.12-5.39-7.42-12.18-7.42s-12.15 3.3-12.15 7.42 5.42 7.28 12.15 7.28 12.18-3.29 12.18-7.28z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.31 305.36c0-4.06-5.49-7.38-12.16-7.38s-12.28 3.32-12.28 7.38 5.56 7.34 12.28 7.34 12.16-3.3 12.16-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.94 280.22c0-4-5.49-7.34-12.22-7.34s-12.11 3.31-12.11 7.34 5.52 7.35 12.11 7.35 12.22-3.36 12.22-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.39 260.87c0-4.05-5.46-7.34-12.08-7.34-6.79 0-12.39 3.29-12.39 7.34s5.6 7.34 12.39 7.34c6.62 0 12.08-3.22 12.08-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67 241.53c0-4.07-5.49-7.3-12.25-7.3s-12.16 3.23-12.16 7.3 5.43 7.33 12.16 7.33 12.25-3.22 12.25-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path306"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.75 228.05c0-4-5.57-7.34-12.29-7.34s-12.15 3.31-12.15 7.34 5.42 7.25 12.15 7.25 12.29-3.19 12.29-7.25z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71 218.31c0-4-5.49-7.33-12.29-7.33-6.59 0-12.22 3.34-12.22 7.33s5.63 7.34 12.22 7.34c6.8 0 12.29-3.35 12.29-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.62 210.63c0-4.06-5.56-7.35-12.26-7.35s-12.24 3.29-12.24 7.35 5.51 7.26 12.24 7.26 12.26-3.22 12.26-7.26z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.37 208.7c0-4-5.53-7.38-12.39-7.38-6.66 0-12.19 3.39-12.19 7.38s5.53 7.3 12.21 7.3c6.86 0 12.39-3.2 12.39-7.25z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.89 210.63c0-4.06-5.5-7.35-12.23-7.35s-12.14 3.29-12.14 7.35 5.41 7.26 12.14 7.26 12.23-3.22 12.23-7.26z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22 334.39c0-4.06-5.53-7.35-12.26-7.35s-12.24 3.29-12.24 7.35 5.49 7.27 12.24 7.27 12.26-3.22 12.26-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.87 309.27c0-4-5.49-7.34-12.18-7.34s-12.19 3.29-12.19 7.34 5.57 7.27 12.19 7.27 12.18-3.23 12.18-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44 287.91c0-4-5.43-7.35-12.18-7.35s-12.15 3.38-12.15 7.35 5.46 7.41 12.15 7.41 12.18-3.29 12.18-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265 272.54c0-4.05-5.52-7.28-12.18-7.28s-12.32 3.23-12.32 7.28 5.63 7.34 12.32 7.34 12.18-3.35 12.18-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34 257c0-4-5.49-7.29-12.3-7.29s-12.2 3.3-12.2 7.29 5.41 7.4 12.2 7.4 12.3-3.29 12.3-7.4z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.38 247.27c0-3.9-5.56-7.33-12.25-7.33s-12.32 3.43-12.32 7.33c0 4.12 5.64 7.43 12.32 7.43s12.25-3.31 12.25-7.43z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.32 241.53c0-4.07-5.49-7.3-12.16-7.3s-12.28 3.23-12.28 7.3 5.53 7.33 12.28 7.33 12.16-3.22 12.16-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.29 233.83c0-4.06-5.49-7.35-12.15-7.35S347 229.77 347 233.83s5.46 7.31 12.16 7.31 12.15-3.33 12.15-7.31z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.34 237.63c0-4-5.56-7.3-12.22-7.3s-12.25 3.3-12.25 7.3 5.53 7.37 12.25 7.37 12.22-3.28 12.22-7.38z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.23 239.6c0-4.13-5.63-7.29-12.19-7.29-6.75 0-12.31 3.16-12.31 7.29s5.56 7.33 12.31 7.33c6.56 0 12.19-3.35 12.19-7.33z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 249.27c0-4.06-5.57-7.4-12.22-7.4s-12.32 3.34-12.32 7.4 5.59 7.36 12.32 7.36S472 253.4 472 249.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.8 258.89c0-4.07-5.52-7.29-12.18-7.29s-12.18 3.22-12.18 7.29 5.48 7.4 12.18 7.4 12.18-3.29 12.18-7.4z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.31 701.79c0-4-5.49-7.3-12.14-7.3s-12.34 3.31-12.34 7.3 5.6 7.38 12.34 7.38 12.14-3.26 12.14-7.38z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.51 701.79c0-4.95-6.79-8.86-14.83-8.86s-14.82 3.91-14.82 8.86 6.66 8.84 14.82 8.84 14.83-3.91 14.83-8.84z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.11 696.84c0-4.81-6.77-8.78-14.84-8.78s-14.86 4-14.86 8.78 6.76 9 14.86 9 14.84-4 14.84-9z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path346"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.75 687.09c0-4.87-6.73-8.86-14.83-8.86s-14.82 4-14.82 8.86 6.79 8.92 14.82 8.92 14.83-4 14.83-8.92z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.37 670c0-4.86-6.62-8.85-14.82-8.85-8 0-14.83 4-14.83 8.85s6.79 8.87 14.83 8.87c8.2 0 14.82-4 14.82-8.87z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.65 648c0-6-8.14-10.78-17.85-10.78s-18 4.8-18 10.78 8.17 10.78 18 10.78c9.7 0 17.85-4.81 17.85-10.78z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.13 621.13c0-5.84-7.86-10.51-17.34-10.51s-17.51 4.67-17.51 10.51 8.07 10.35 17.51 10.35 17.34-4.66 17.34-10.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.76 594.21c0-6-8-10.83-17.94-10.83s-18 4.86-18 10.83 8.17 10.7 18 10.7 17.94-4.72 17.94-10.7z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2 560c0-5.89-8.13-10.77-17.89-10.77-9.91 0-17.87 4.88-17.87 10.77s8 10.79 17.87 10.79c9.76 0 17.89-4.87 17.89-10.79z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.49 525.71c0-5.78-7.92-10.38-17.36-10.38-9.65 0-17.41 4.6-17.41 10.38s7.76 10.43 17.41 10.43c9.44 0 17.36-4.68 17.36-10.43z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59 484.1c0-4-5.49-7.27-12.29-7.27s-12.19 3.23-12.19 7.27 5.47 7.35 12.19 7.35 12.29-3.29 12.29-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.65 447.45c0-4-5.56-7.28-12.22-7.28s-12.12 3.29-12.12 7.28 5.43 7.34 12.12 7.34 12.22-3.3 12.22-7.34z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05 405.93c0-4.12-5.42-7.43-12.18-7.43s-12.19 3.31-12.19 7.43c0 4 5.46 7.27 12.19 7.27s12.18-3.3 12.18-7.27z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.83 366.72c0-4-5.42-7.34-12.15-7.34s-12.29 3.36-12.29 7.34 5.56 7.37 12.29 7.37 12.15-3.31 12.15-7.37z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.59 288.4c0-3.92-5.53-7.28-12.32-7.28s-12.22 3.37-12.22 7.28c0 4.12 5.56 7.41 12.22 7.41s12.32-3.29 12.32-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.59 325.13c0-4-5.53-7.28-12.32-7.28s-12.22 3.3-12.22 7.28 5.56 7.35 12.22 7.35 12.32-3.31 12.32-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.81 254.28c0-4.05-5.6-7.35-12.15-7.35-6.83 0-12.39 3.3-12.39 7.35s5.56 7.35 12.39 7.35c6.55 0 12.15-3.38 12.15-7.35z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.83 224.9c0-4.06-5.39-7.28-12.18-7.28s-12.22 3.22-12.22 7.28 5.53 7.41 12.22 7.41 12.18-3.36 12.18-7.41z",
    fill: "#f29d26",
    fillRule: "evenodd",
    id: "path376"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisteon);
export default __webpack_public_path__ + "static/media/visteon.fcdad8000bfe16853ce863af603a1d62.svg";
export { ForwardRef as ReactComponent };